/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect } from 'react';
import { DatePicker } from '@scuf/common';

import IDatePickerProps from '@scuf/common/dist/components/DatePicker/IDatePickerProps';
import './DateRangeWrapperTheme.scss';

export interface IDateRangeWrapperProps extends IDatePickerProps {
  className: string;
  id: string;
  scrollableParentRef?: React.RefObject<HTMLElement>;
}

/**
 * This wrapper is introduced for scenarios where
 * the date picker is inside a scrollable container for width less than calendar width
 * and when input is clicked, calendar creates x scroll or is partially hidden
 */
export const DateRangeWrapper = (props: IDateRangeWrapperProps) => {
  const { className, id } = props;
  const moveCalendarOnScroll = () => {
    const input = document.querySelector(
      `#${id} .${className} .datetime-input-wrap`
    );
    const calendar = document.querySelector(
      `#${id} .${className} .calendar-overlay`
    );
    if (input && calendar) {
      calendar.setAttribute(
        'style',
        `
        top: ${input.getBoundingClientRect().bottom}px !important;
        `
      );
    }
  };
  useEffect(() => {
    const input = document.querySelector(`#${id} .${className}`);
    input?.addEventListener('click', moveCalendarOnScroll);
    if (props.scrollableParentRef && props.scrollableParentRef.current) {
      props.scrollableParentRef?.current?.addEventListener(
        'scroll',
        moveCalendarOnScroll
      );
    } else {
      window.addEventListener('wheel', moveCalendarOnScroll);
    }
    return () => {
      input?.removeEventListener('click', moveCalendarOnScroll);
      window.removeEventListener('wheel', moveCalendarOnScroll);
      props.scrollableParentRef?.current?.removeEventListener(
        'scroll',
        moveCalendarOnScroll
      );
    };
  }, []);
  return (
    <div className="daterangepricker-wrapper" id={id}>
      <DatePicker type="daterange" {...props} />
    </div>
  );
};
